import axios from 'axios';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

let authHeader = localStorage.getItem('AUTH_HEADER', '');

// Use an interceptor to automatically add the Authorization header
apiClient.interceptors.request.use(
  (config) => {
    if (authHeader) {
      config.headers['Authorization'] = authHeader;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const setAuthHeader = (newAuthHeader) => {
  authHeader = newAuthHeader;
  localStorage.setItem('AUTH_HEADER', newAuthHeader);
};

const removeAuthHeader = () => {
  authHeader = '';
  localStorage.removeItem('AUTH_HEADER');
};

const get = async (path, params) => {
  try {
    const response = await apiClient.get(path, { params });
    return response.data;
  } catch (err) {
    console.error('Error getting', path, err);
    return null;
  }
};

const post = async (path, body) => {
  try {
    const response = await apiClient.post(path, body);
    return response.data;
  } catch (err) {
    console.error('Error posting', path, err);
    return null;
  }
};

const put = async (path, body) => {
  try {
    const response = await apiClient.put(path, body);
    return response.data;
  } catch (err) {
    console.error('Error putting', path, err);
    return null;
  }
};

const patch = async (path, body) => {
  try {
    const response = await apiClient.patch(path, body);
    return response.data;
  } catch (err) {
    console.error('Error patching', path, err);
    return null;
  }
};

const _delete = async (path, body) => {
  try {
    const response = await apiClient.delete(path, { data: body });
    return response.data;
  } catch (err) {
    console.error('Error deleting', path, err);
    return null;
  }
};

const download = async (url) => {
    try {
        const result = await apiClient.get(url, {
            responseType: 'blob',
        });
        const href = window.URL.createObjectURL(result.data);
        const link = document.createElement('a');
        link.href = href;
        // You might need to set a filename here depending on your needs
        // link.setAttribute('download', 'file.pdf');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } catch (err) {
        console.error('Error downloading', url, err);
        return null;
    }
};

export {
  get,
  post,
  put,
  patch,
  _delete,
  setAuthHeader,
  removeAuthHeader,
  download,
};
